import { Injectable } from '@angular/core';

@Injectable()
export class LoadingService {
    private showSpinner = true;
    private pageSpinner = false;

    constructor() {
    }

    mustShowSpinner() {
        return this.showSpinner;
    }

    public enableShowSpinner() {
        this.showSpinner = true;
    }

    public disableShowSpinner() {
        this.showSpinner = false;
    }

    mustShowPageSpinner() {
        return this.pageSpinner;
    }

    public enableShowPageSpinner() {
        this.pageSpinner = true;
    }

    public disableShowPageSpinner() {
        this.pageSpinner = false;
    }
}
